
export default {
    props:['cart','passive']

}
